import { User } from "./User";

// e.g. in a constants or roles file
export const ROLES = {
  ADMIN: 'Admin',
  USER: 'User',
} as const;

export const isAdmin = (user: User | null) => 
    user?.userRole?.toLowerCase() === ROLES.ADMIN.toLowerCase();